import axios from 'axios'
import {$authToken, setToken} from "../Hooks/useAuth";

export const instance = axios.create({
    baseURL: 'https://api.exhot.ru/api',
    timeout: 10000,
    /*headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}*/
});
instance.interceptors.request.use((req)=>{
    //@ts-ignore
    req.headers = {...req.headers, 'Authorization': `Bearer ${$authToken.getState()}`}
    return req
})
export async function login(email:string, password:string) {
    const data = {
        email: email,
        password: password
    }

    const res = await instance.post('/login', data);

    if(res.data?.access_token){
        setToken(res.data.access_token)
    }
}
